<template>
  <div>
    <div class="slideContainer">
      <input  @input="$emit('input', $event.target.value)" class="custom-range range-slider" type="range" min="0" max="100" v-model="value">
      <span class="range-slider-value">{{ value }} % </span>
    </div>

  </div>
</template>

<script>
export default {
  name: "RangeSlider",
  props: {
    initial: {
      default: 0
    }
  },
  data() {
    return {
      value: 0
    }
  },
  mounted() {
    this.value = this.initial;
  }
}
</script>

<style scoped lang="scss">

input[type=range]::-webkit-slider-thumb:hover {
  background: #2D3032;
}

input[type=range] {
  -webkit-appearance: none;
  appearance: none;
  width: calc(100% - 75px);
  height: 10px;
  border-radius: 5px;
  background: #dee2e6;
  outline: none;
  padding: 0;
  margin: 0;
  -webkit-transition: .2s;
  transition: opacity .2s;
}

input[type=range]::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: #d70364;
  cursor: pointer;
  transition: background .15s ease-in-out;
}

.range-slider-value {
  display: inline-block;
  position: relative;
  width: 66px;
  color: #fff;
  line-height: 20px;
  text-align: center;
  border-radius: 3px;
  background: #d70364;
  padding: 5px 10px;
  margin-left: 8px;
}

.range-slider-value:after {
  position: absolute;
  top: 8px;
  left: -7px;
  width: 0;
  height: 0;
  border-top: 7px solid transparent;
  border-right: 7px solid #d70364;
  border-bottom: 7px solid transparent;
  content: '';
}
</style>